import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LabelSelectionComponent } from '@app/pcs/shared/labels/label-selection/label-selection.component';
import { LabelSelectionItemComponent } from '@app/pcs/shared/labels/label-selection/label-selection-item.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    LabelSelectionItemComponent,
    LabelSelectionComponent
  ],
  exports: [
    LabelSelectionItemComponent,
    LabelSelectionComponent
  ]
})
export class LabelSelectionModule {
}
